/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  InfoResponseBody,
  InfoResponseBody$inboundSchema,
} from "../components/inforesponsebody.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SessionInfoSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SessionInfoRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type SessionInfoResponse = {
  headers: { [k: string]: Array<string> };
  result: InfoResponseBody;
};

/** @internal */
export type SessionInfoSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SessionInfoSecurity$outboundSchema: z.ZodMiniType<
  SessionInfoSecurity$Outbound,
  SessionInfoSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function sessionInfoSecurityToJSON(
  sessionInfoSecurity: SessionInfoSecurity,
): string {
  return JSON.stringify(
    SessionInfoSecurity$outboundSchema.parse(sessionInfoSecurity),
  );
}

/** @internal */
export type SessionInfoRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const SessionInfoRequest$outboundSchema: z.ZodMiniType<
  SessionInfoRequest$Outbound,
  SessionInfoRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function sessionInfoRequestToJSON(
  sessionInfoRequest: SessionInfoRequest,
): string {
  return JSON.stringify(
    SessionInfoRequest$outboundSchema.parse(sessionInfoRequest),
  );
}

/** @internal */
export const SessionInfoResponse$inboundSchema: z.ZodMiniType<
  SessionInfoResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
    Result: InfoResponseBody$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
      "Result": "result",
    });
  }),
);

export function sessionInfoResponseFromJSON(
  jsonString: string,
): SafeParseResult<SessionInfoResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SessionInfoResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SessionInfoResponse' from JSON`,
  );
}
